export * from './AnimatedComponent';
